export function Subscriber (user, listid) {
  this.user = {
    status: 'subscribed',
    list: listid,
    email_address: user.email_address,
    merge_fields: {
      NAME: user.name,
      PHONE: user.tel,
      ADDRESS: user.fullAddress
    }
  }
}
